import axios from 'axios';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['x-module'] = 'admin';

  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    const tenantId = localStorage.getItem('selectedTenant');
    config.headers['x-tenant-id'] = tenantId;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('auth_user');
      
      // Redirect to unauthorized page
      window.location.href = '/unauthorized';
    }
    return Promise.reject(error);
  }
);